import {ColorDot} from 'components/utils/ColorDot';
import React from 'react';
import './MeetingCategoriesDropdown.styl';
import classNames from 'classnames';
import SimpleDropdown from 'charts/components/forms/SimpleDropdown';

export const MeetingCategoriesDropdown = ({
  meetingCategories,
  meetingCategoryId,
  onChange,
  className,
  placeholder,
  allowReset,
  ...props
}) => {
  const meetingCategoryOptions = meetingCategories && [
    ...(allowReset
      ? [
          {
            id: undefined,
            name: (
              <div className="option-display">
                <ColorDot color={'gray'} size={15} />
                <span className="category-name">All Meeting Categories</span>
              </div>
            ),
          },
        ]
      : []),
    ...meetingCategories
      .filter(c => !c.hidden)
      .map(o => ({
        id: o.id,
        name: (
          <div className="option-display">
            <ColorDot color={o.color} size={15} />
            <span className="category-name">{o.name}</span>
          </div>
        ),
      }))
      .toList()
      .toJS(),
  ];

  const meetingCategoryValue = meetingCategoryOptions.find(o => o.id === meetingCategoryId);

  return (
    <div className={classNames('meeting-categories-dropdown', className)}>
      <SimpleDropdown
        placeholder={placeholder}
        selections={meetingCategoryOptions}
        onSelect={onChange}
        value={meetingCategoryValue}
        {...props}
      />
    </div>
  );
};
